import { GetStaticProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { PasswordSettingSection } from '../../components/organisms/PasswordSettingSection'
import { DefaultPageTemplate } from '../../components/templates/DefaultPageTemplate'
import { SessionContentTemplate } from '../../components/templates/SessionContentTemplate'
import { SignUpFooter } from '../../components/molecules/SignUpFooter'
import { MyHead } from '../../components/molecules/MyHead'

const Step1: NextPage = () => {
  const { t } = useTranslation(['password-recovery'])
  return (
    <DefaultPageTemplate>
      <MyHead title={t('パスワード再設定')} />
      <SessionContentTemplate title={t('パスワード再設定')} footer={<SignUpFooter />}>
        <PasswordSettingSection />
      </SessionContentTemplate>
    </DefaultPageTemplate>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    forcedTheme: 'light',
    ...(await serverSideTranslations(locale, ['global', 'validation', 'signup', 'password-recovery'])),
  },
})

export default Step1
